import type { PermissionSelector } from "@/hooks/usePermission";

export const canManageStatuses: PermissionSelector = (x) => x.isAdmin && x.repairManagement.canManageStatuses;
export const canListStatuses: PermissionSelector = (x) => x.isAdmin && x.repairManagement.canListStatuses;
